export const categories = [
  {
    id: "video",
    name: "视频平台",
    slug: "video",
    icon: "ri-movie-line",
    description: "精选优质视频内容平台，高清流畅播放体验",
    count: 28,
  },
  {
    id: "live",
    name: "直播平台",
    slug: "live",
    icon: "ri-live-line",
    description: "实时互动直播平台，精彩内容不间断",
    count: 16,
  },
  {
    id: "image",
    name: "图片图库",
    slug: "image",
    icon: "ri-image-line",
    description: "海量高清图片资源，每日更新精选内容",
    count: 35,
  },
  {
    id: "novel",
    name: "小说文学",
    slug: "novel",
    icon: "ri-book-open-line",
    description: "丰富多样的文学作品，满足各类阅读喜好",
    count: 22,
  },
  {
    id: "comic",
    name: "动漫漫画",
    slug: "comic",
    icon: "ri-paint-brush-line",
    description: "日韩欧美动漫漫画资源，高清画质体验",
    count: 19,
  },
  {
    id: "forum",
    name: "社区论坛",
    slug: "forum",
    icon: "ri-chat-1-line",
    description: "活跃的交流社区，分享讨论热门话题",
    count: 14,
  },
  {
    id: "tool",
    name: "实用工具",
    slug: "tool",
    icon: "ri-tools-line",
    description: "各类实用工具软件，提升使用体验",
    count: 12,
  },
  {
    id: "game",
    name: "游戏娱乐",
    slug: "game",
    icon: "ri-gamepad-line",
    description: "成人向游戏资源，丰富娱乐体验",
    count: 18,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};